import type { LucideIcon } from "lucide-react";

type IconButtonProps = {
  icon: LucideIcon;
  label: string;
  onClick?: () => void;
  selected?: boolean;
};

export function IconButton({ icon: Icon, label, onClick, selected = false }: IconButtonProps) {
  return (
    <button
      type="button"
      className="icon-button"
      aria-label={label}
      aria-pressed={selected}
      onClick={onClick}
    >
      <Icon aria-hidden="true" size={20} strokeWidth={1.6} />
    </button>
  );
}

